/**
 * Created by User on 10-Aug-17.
 */
import React from 'react';

import { NavLink } from 'react-router-dom';

import {Table} from 'react-bootstrap';
import NotificationTypes from '../../../../data/NotificationsTypes';

const SentTable = (props) => {
    const {isArchive} = props;
    let {sent} = props;
    sent = sent ? sent : [];


    const rows = sent.map(notification => {
        let {type} = notification;
        if(type || type === 0) {
            type = NotificationTypes[type];
        }
        return (
            <tr key={notification.id}>
                <td>{notification.sendTime}</td>
                <td><NavLink to={`/notification/${notification.tagid}${isArchive ? '/archive' : ''}`}>{notification.body}</NavLink></td>
                <td>{notification.sent}</td>
                <td>{type}</td>
                <td>{notification.keyword}</td>
                <td>{notification.clickRate}%</td>
            </tr>
        );
    });
    return (

        <Table bordered responsive>
            <thead>
            <tr>
                <th>Sent At</th>
                <th>Body</th>
                <th>Sent</th>
                <th>Type</th>
                <th>Keyword</th>
                <th>Click Rate</th>
            </tr>
            </thead>
            <tbody>
            {rows}
            </tbody>
        </Table>
    );
}

export default SentTable;


// WEBPACK FOOTER //
// ./src/scenes/Sent/components/SentTable/index.js